import React, { useState } from 'react';
import { Navbar, Button, Container } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import UserDetailsPanel from './UserDetailsPanel';
import './Header.css';

const Header: React.FC = () => {
    const { user } = useAuth();
    const [showUserPanel, setShowUserPanel] = useState(false);

    const handleSupportClick = () => {
        const supportNumber = '+5541998110350';
        const defaultMessage = encodeURIComponent('Olá! Preciso de ajuda com o sistema FlowGov - Gestão de Ações.');
        const whatsappUrl = `https://wa.me/${supportNumber}?text=${defaultMessage}`;

        window.open(whatsappUrl, '_blank');
    };

    return (
        <>
            <Navbar className="header-navbar" variant="dark">
                <Container fluid>
                    <Navbar.Brand href="/home">FlowGov - Gestão de Ações</Navbar.Brand>
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="link"
                            className="support-button"
                            onClick={handleSupportClick}
                            title="Suporte via WhatsApp"
                        >
                            <i className="bi bi-whatsapp"></i>
                        </Button>
                        {user && (
                            <Button
                                variant="link"
                                className="user-menu-button"
                                onClick={() => setShowUserPanel(true)}
                            >
                                <i className="bi bi-person-circle"></i>
                            </Button>
                        )}
                    </div>
                </Container>
            </Navbar>

            <UserDetailsPanel
                show={showUserPanel}
                onHide={() => setShowUserPanel(false)}
            />
        </>
    );
};

export default Header; 